<template>
  <div class="app-box">
    <router-view />
  </div>
</template>
<script>
import { getTime } from "@/utils/common";
export default {
  methods: {},
  mounted() {
    getTime();
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.app-box {
  height: 100%;
}
</style>
